/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import slice from 'lodash/slice';

import { INVITE_STATE, REDIRECT_ACTION } from 'utils/social-ecomm';
import { VIEW_SIZE } from 'utils/device';
import PreviewProductsDesktop from './PreviewProductsDesktop/PreviewProductsDesktop';
import PreviewProductsMobile from './PreviewProductsMobile/PreviewProductsMobile';

const TITLE = 'Take a Sneak Peek';
const SUBTITLE =
  "Here's a taste of a few premium products you'll get to choose from.";

const formatProducts = (products, productCount) => {
  const formattedProducts = map(products, (value) => {
    const { brandName, name, defaultVariantId, variants } = value;
    const defaultVariant = get(variants, defaultVariantId, {});
    const { salePrice, price, percentOff, imageUrl } = defaultVariant;
    return {
      brandName,
      name,
      price,
      salePrice,
      percentOff,
      imageUrl,
    };
  });
  return slice(formattedProducts, 0, productCount);
};

const PreviewProducts = ({
  viewSize,
  products,
  inviteState,
  toggleInviteModal,
  inviteCode,
  handleRedeemInviteTracking,
}) => {
  const formattedProducts = formatProducts(products, 8);

  const PREVIEW_SALE_STATE = {
    [INVITE_STATE.redeemed_sale]: {
      buttonText: 'send invite',
      buttonAction: toggleInviteModal,
    },
    [INVITE_STATE.invite_invalid]: {
      buttonText: 'login to reveal pricing',
      buttonAction: REDIRECT_ACTION.login,
    },
    [INVITE_STATE.invite_expired]: {
      buttonText: 'join now to reveal pricing',
      buttonAction: REDIRECT_ACTION.getTheBox,
    },
    [INVITE_STATE.unredeemed]: {
      buttonText: 'redeem to reveal pricing',
      buttonAction: () => {
        handleRedeemInviteTracking('REDEEM TO REVEAL PRICING');
        REDIRECT_ACTION.createAccount(inviteCode);
      },
    },
    [INVITE_STATE.member]: {
      buttonText: 'redeem invite',
      buttonAction: () => {
        handleRedeemInviteTracking('REDEEM INVITE');
        REDIRECT_ACTION.createAccount(inviteState);
      },
    },
    [INVITE_STATE.seasonal]: {
      buttonText: 'upgrade now',
      buttonAction: REDIRECT_ACTION.upgrade,
    },
    [INVITE_STATE.expired]: {
      buttonText: 'reactivate now',
      buttonAction: REDIRECT_ACTION.reactivate,
    },
  };

  const { buttonAction, buttonText } = get(PREVIEW_SALE_STATE, inviteState, {
    buttonText: '',
    buttonAction: () => {},
  });

  return (
    <>
      {viewSize === VIEW_SIZE.small ? (
        <PreviewProductsMobile
          products={formattedProducts}
          title={TITLE}
          subtitle={SUBTITLE}
          buttonText={buttonText}
          buttonAction={buttonAction}
        />
      ) : (
        <PreviewProductsDesktop
          products={formattedProducts}
          title={TITLE}
          subtitle={SUBTITLE}
          buttonText={buttonText}
          buttonAction={buttonAction}
        />
      )}
    </>
  );
};

PreviewProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  viewSize: PropTypes.string.isRequired,
  inviteState: PropTypes.string.isRequired,
  toggleInviteModal: PropTypes.func,
  inviteCode: PropTypes.string,
  handleRedeemInviteTracking: PropTypes.func.isRequired,
};

PreviewProducts.defaultProps = {
  toggleInviteModal: () => {},
  inviteCode: null,
};

export default PreviewProducts;
